/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The FolderCreationUpdateRequest model module.
 * @module model/FolderCreationUpdateRequest
 * @version v0
 */
export default class FolderCreationUpdateRequest {
  /**
   * Constructs a new <code>FolderCreationUpdateRequest</code>.
   * @alias module:model/FolderCreationUpdateRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>FolderCreationUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FolderCreationUpdateRequest} obj Optional instance to populate.
   * @return {module:model/FolderCreationUpdateRequest} The populated <code>FolderCreationUpdateRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new FolderCreationUpdateRequest();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} name
 */
FolderCreationUpdateRequest.prototype.name = undefined;

